import { ReactNode, memo, ComponentProps } from 'react';
import { Button } from '@bridebook/aura';

interface IProps {
  onClick: () => void;
  text: string;
  icon: ReactNode;
  variant?: ComponentProps<typeof Button>['variant'];
  size?: ComponentProps<typeof Button>['size'];
  disabled?: boolean;
  loading?: boolean;
}

const VariantAuthButton = ({
  onClick,
  text,
  icon,
  variant = 'tertiary',
  size = 'lg',
  disabled,
  loading,
}: IProps) => (
  <Button size={size} variant={variant} onClick={onClick} disabled={disabled} loading={loading}>
    <div className="flex items-center justify-center gap-2">
      {icon}
      <span>{text}</span>
    </div>
  </Button>
);

export default memo(VariantAuthButton);
